import { z } from "zod";
import { reviewCategories } from "../../constants/reviewCategories";

const singleFeedbackSchema = z.object({
  rating: z.number().min(1, "Rating is required"),

  review: z
    .string()
    .trim()
    .min(1, "Feedback Review is required")           // catches empty string first
    .min(10, "Review must be at least 10 characters")  // then catches too-short
    .max(10000, "Review must be 10000 characters or fewer"),
});

export const feedbackSchema = z.object({
  feedback: z.object(
    reviewCategories.reduce((acc, cat) => {
      acc[cat.id] = singleFeedbackSchema;
      return acc;
    }, {}),
  ),

  additionalNotes: z
    .string()
    .trim()
    .max(10000, "Additional notes must be 10000 characters or fewer")
    .optional(),
});